// Open navi

const vysunuti = document.getElementById('navi-toggle');
const mobil = document.getElementById('mobil');

vysunuti.addEventListener('click', () =>
  mobil.classList.toggle('show-navi')
);